import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../../../components/Modal';
import Steps from '../../../components/Steps';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import FourthStep from './FourthStep';
import { fetchEntidadFinanciera, fetchFormaPago, fetchTipoDocumento, fetchMaestroTipoSolicitudFacturacion, fetchColaboradores, clearColaboradores, fetchGrabarFacturacion, fetchContactosClientes } from '../../../actions';
import getClienteDirecciones from '../../../utils/getClienteDirecciones';
import Alert from '../../../components/Alert';
import _ from 'lodash';

const IND_INACTIVO = 'N';
const IND_SOLICITUD_FACTURACION = 'S';
const VACIO = '';
const VACIO_PATH='123'
const TIPO_SOLICITUD_FACTURACION = '45';

class SolicitarFacturacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      colaboradoresSeleccionados: [],
      formaPagoOption:[],
      documentoRadio:'',
      entidadFinancieraOption:'',
      contactos: [],
      direcciones: [],
      colaborador:'',
      clientes:props.pedidos.map(row=>({
        'codClie': row.codClie,
        'numPedidoVeh': row.numPedidoVeh,
        'numPedidoVehString': row.numPedidoVeh.toString(),
        'documento': row.desTipoDoc,
        'tipoPago': row.desFormPago,
        'entidadFinanciera': row.entidadFinancieraProf,
        'direccion': '',
        'contactos': [{ 'id': 1, 'nombre': '', 'correo': '' }],
        'tipoSolicitud': '',
        'observaciones': '',
        'codProv': row.codProv,
        'codCIA': row.codCIA,
        'numProfVeh':row.numProfVeh,
        'estadoTransitoFact':row.estadoTransitoFact
      })),
      countContactos:2,
      arrayAsignarFacturacion : [],
      facturacionListado:props.facturacionListado,
      facturacionListadoCheckBox:props.facturacionListado,
      facturacionListadoSeleccionado:[],
      pedidos:props.pedidos,
      pedidosSeleccionadosTabFacturacion:[],
      alertWarnnigOpen:false
    };
  }

  showAlert = (alertType) => {
     this.setState({ [alertType]: true });
     setTimeout(() => this.setState({ [alertType]: false }), 5000);
   }

 closeAlert = () => this.setState({ alertWarnnigOpen: false });

  componentDidMount() {
    this.props.fetchFormaPago();
    this.props.fetchEntidadFinanciera();
    this.props.fetchTipoDocumento();
    this.props.fetchMaestroTipoSolicitudFacturacion(TIPO_SOLICITUD_FACTURACION);
    this.props.fetchColaboradores('');
    getClienteDirecciones(this.props.pedidos.map((row)=>(row.codClie))).then(result=>{

            this.state.clientes.forEach(data =>{
              _.filter(result, _.property(data.codClie))[0][data.codClie].forEach(entry => {
                if(entry===undefined){
                  result[1][data.codClie]=[{cod:''}];
                }
              })
            })
      this.setState({direcciones:result});
    });
  }

  removePedidos = (pedido) =>{

    this.setState({facturacionListadoCheckBox:this.state.facturacionListadoCheckBox.filter(x => x.numPedidoVeh !== pedido)});
    this.setState({facturacionListadoSeleccionado:[...this.state.facturacionListadoSeleccionado,pedido]})

    if (this.props.llamadaProformaOrTabProforma===1){
      let pedidosSeleccionadosTabFacturacion=this.state.pedidosSeleccionadosTabFacturacion;
      pedidosSeleccionadosTabFacturacion.push(pedido);
      this.cargarPedidosAndClientesTabFacturacion(pedidosSeleccionadosTabFacturacion)
    };
    this.addPedidosAsignarFacturacion(pedido);

  }

  fnRemovePedidosSeleccionados = (pedido) =>{

    this.setState({facturacionListadoSeleccionado:this.state.facturacionListadoSeleccionado.filter(numPedidoVeh => numPedidoVeh !== pedido)});
    this.setState({facturacionListadoCheckBox:[...this.state.facturacionListadoCheckBox,
      this.props.facturacionListado.filter(pedidoFacturacion => pedidoFacturacion.numPedidoVeh===pedido)[0]
    ]})

    this.cargarPedidosAndClientesTabFacturacion(this.state.pedidosSeleccionadosTabFacturacion.filter(entry => entry !==pedido))
    this.setState({pedidosSeleccionadosTabFacturacion:this.state.pedidosSeleccionadosTabFacturacion.filter(entry => entry !==pedido)})

  }

  cargarPedidosAndClientesTabFacturacion = (pedidosSeleccionadosTabFacturacion) =>{

    const ped = this.props.facturacionListadoModal
    .filter(element => element.numPedidoVeh.split(' ').filter(z => pedidosSeleccionadosTabFacturacion.filter(y => y === z).length !== 0).length !== 0);

    const pedidosSeleccionados =
              ped.map((row) => {
                console.log(pedidosSeleccionadosTabFacturacion)
                const numPedidos = row.numPedidoVeh.split(' ').filter(z =>pedidosSeleccionadosTabFacturacion.filter(y => y === z).length !== 0);
                console.log(numPedidos)
                return {
                  'numPedidoVeh': numPedidos,
                  'codClie': row.codClie,
                  'desClie': row.desClie,
                  'rucClie': row.rucClie,
                  'dniClie': row.dniClie,
                  'desFormPago': row.desFormPago,
                  'desPropietarioVeh': row.desPropietarioVeh,
                  'desTipoDoc': row.desTipoDoc,
                  'desUsuarioVeh': row.desUsuarioVeh,
                  'entidadFinancieraProf': row.entidadFinancieraProf,
                  'nomUsuarioSolFact': row.nomUsuarioSolFact,
                  'tipoSolFact': row.tipoSolFact,
                  'codProv': row.codProv,
                  'codCIA': row.codCIA,
                  'numProfVeh':row.numProfVeh,
                  'estadoTransitoFact':row.estadoTransitoFact
                };
              });


        const clientes=pedidosSeleccionados.map(row=>({
            'codClie': row.codClie,
            'numPedidoVeh': row.numPedidoVeh,
            'numPedidoVehString': row.numPedidoVeh.toString(),
            'documento': row.desTipoDoc,
            'tipoPago': row.desFormPago,
            'entidadFinanciera': row.entidadFinancieraProf,
            'direccion': '',
            'contactos': [{ 'id': 1, 'nombre': '', 'correo': '' }],
            'tipoSolicitud': '',
            'observaciones': '',
            'codProv': row.codProv,
            'codCIA': row.codCIA,
            'numProfVeh':row.numProfVeh,
            'estadoTransitoFact':row.estadoTransitoFact
          }));



  getClienteDirecciones(pedidosSeleccionados.map((row)=>(row.codClie))).then(result=>{

      clientes.forEach(data =>{
        _.filter(result, _.property(data.codClie))[0][data.codClie].forEach(entry => {
          if(entry===undefined){
            result[1][data.codClie]=[{cod:''}];
          }
        })
      })

        this.setState({
          pedidos: pedidosSeleccionados,
          clientes:clientes,
          direcciones:result
        });
      });
  }

  addPedidosAsignarFacturacion = (items) => {

    if(this.state.arrayAsignarFacturacion.indexOf(items)>=0){
      this.setState({
        arrayAsignarFacturacion: this.state.arrayAsignarFacturacion.filter(x => x !== items),
      });
    }else{
      this.setState({arrayAsignarFacturacion: [...this.state.arrayAsignarFacturacion,items]});
    }
  }

  grabarFacturacion = () =>{

      this.props.loading('block');
      const promises = [];
      let conditional=0;
      const colaborador = this.state.colaboradoresSeleccionados.map(colaborado=>colaborado.id);
      this.state.clientes.forEach((rowClientes) => {

        const documento = rowClientes.documento === null ||  rowClientes.documento === undefined ? [] : rowClientes.documento.split("-")
        const direccion = rowClientes.direccion === null ? [] : rowClientes.direccion.split("-")
        const entidadFinanciera = rowClientes.entidadFinanciera === null ||  rowClientes.entidadFinanciera === undefined ? [] : rowClientes.entidadFinanciera.split("-")
        const tipoPago = rowClientes.tipoPago === null ||  rowClientes.tipoPago === undefined ? [] : rowClientes.tipoPago.split("-")

        if(tipoPago[0]===undefined || documento[0]===undefined ){
            this.showAlert('alertWarnnigOpen');
            conditional=1
        }else{

        rowClientes.numPedidoVeh.forEach((pedido, key) => {
          let nurPedido = this.props.nurPedidos.filter(nurPedido => nurPedido.numPedidoVeh===pedido);
          console.log('logger',this.props.nurPedidos);
          console.log('logger',nurPedido);
          promises.push(
            this.props.fetchGrabarFacturacion(
              this.props.idFichaVenta,
              pedido,
              rowClientes.codCIA,
              colaborador,
              documento[0],
              tipoPago[0]==='1'?'':entidadFinanciera[0],
              VACIO,
              direccion[0],
              rowClientes.codProv,
              tipoPago[0],
              rowClientes.tipoSolicitud.substring(1, 2),
              VACIO,
              direccion[2],
              documento[1],
              tipoPago[0]==='1'?'':entidadFinanciera[1],
              IND_INACTIVO,
              IND_SOLICITUD_FACTURACION,
              VACIO,
              this.props.idFichaVenta,
              pedido,
              rowClientes.numProfVeh,
              direccion[1],
              rowClientes.observaciones,
              VACIO,
              rowClientes.observaciones,
              VACIO,
              VACIO,
              VACIO,
              VACIO,
              rowClientes.tipoSolicitud,
              nurPedido.length>0?nurPedido[0].nurFichaVtaPedido:''
            )
          )
        })
        rowClientes.contactos.forEach((contacto) =>
          promises.push(this.props.fetchContactosClientes(rowClientes.codClie, rowClientes.codClie, VACIO, contacto.correo, IND_INACTIVO, contacto.nombre))
        )
      }

      });

   if(conditional!==1){

        Promise.all(promises)
          .then((results) => {
            this.props.loading('none');
            this.props.closeModal();
            results.forEach((element, k) => {

                this.props.openAlert(element.payload.data);
                this.props.fnSolicitudFacturacion(this.props.idFichaVenta,VACIO_PATH,VACIO);
                this.props.fnListadoPedidosFacturacion(this.props.idFichaVenta)

            })
          });

    }else{
      this.props.loading('');
    }
    if(this.props.whereRunTabOrProf!=='1'){
          this.props.fnUnSelectedAll();
    }

  }

  getCliente = (codClie, estadoTransitoFact) =>{
    console.log('logger',codClie);
    console.log('logger',estadoTransitoFact);
     console.log('logger',this.state.clientes.find(z=>z.codClie===codClie && z.estadoTransitoFact===estadoTransitoFact));
    return this.state.clientes.find(z=>z.codClie===codClie && z.estadoTransitoFact===estadoTransitoFact);
  }

  selectColaborador = (key) => {
    const colaboradorSelected = this.state.colaboradoresSeleccionados.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;
      const apellidos = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };
      this.setState({ colaborador: '', colaboradoresSeleccionados: [...this.state.colaboradoresSeleccionados, colaborador] });
      this.props.clearColaboradores();
    }
  }

  removeColaborador = (id) => {
    const { colaboradoresSeleccionados } = this.state;
    this.setState({ colaboradoresSeleccionados: colaboradoresSeleccionados.filter(colaborador => id !== colaborador.id) });
  }

  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  onChangeValue = e => {
    console.log(e);
      this.setState({ [e.target.name]: e.target.value })
  }

  nextStep = () => {
      this.setState({ step: this.state.step + 1 });

  }

  previousStep = () => this.setState({ step: this.state.step - 1 })

  changeOptionFormaPago = (e,codClie, estadoTransitoFact) =>{
    this.setState({ clientes:  this.state.clientes.map(z=>z.codClie===codClie && z.estadoTransitoFact===estadoTransitoFact ?Object.assign({},z, {'tipoPago':e.target.value}):z) });
  }

  changeRadioDocumento = (e,codClie, estadoTransitoFact) =>{
    this.setState({ clientes:  this.state.clientes.map(z=>z.codClie===codClie && z.estadoTransitoFact===estadoTransitoFact?Object.assign({},z, {'documento':e.target.value}):z) });
  }

  changeState = (e,codClie,estadoTransitoFact) =>{

    this.setState({ clientes:  this.state.clientes.map(z=>{
        if(z.codClie===codClie && z.estadoTransitoFact===estadoTransitoFact){
          return Object.assign({},z, {[e.target.id]:e.target.value});
        }else{
          return z;
        }
      })
    });
  }

  changeOptionEntidadFinanciera = (e, codClie, estadoTransitoFact) => {
    console.log("changeOptionDireccion=",estadoTransitoFact)
    this.setState({ clientes: this.state.clientes.map(z => z.codClie === codClie && z.estadoTransitoFact===estadoTransitoFact ? Object.assign({}, z, { 'entidadFinanciera': e.target.value }) : z) });
  }

  changeOptionDireccion = (e, codClie, estadoTransitoFact) => {
    console.log("changeOptionDireccion=",codClie)
    console.log("changeOptionDireccion=",estadoTransitoFact)
    this.setState({ clientes: this.state.clientes.map(z => z.codClie === codClie && z.estadoTransitoFact===estadoTransitoFact ? Object.assign({}, z, { 'direccion': e.target.value }) : z) });
  }

  clickQuitarContacto = (e, id, codClie) => {
    this.setState({ clientes: this.state.clientes.map(z => z.codClie === codClie ? Object.assign({}, z, { 'contactos': z.contactos.filter(contact => contact.id !== id) }) : z) });
  }

  clickAgregarContacto = (e, codClie, estadoTransitoFact) => {

    this.setState({ clientes: this.state.clientes.map(z => z.codClie === codClie && z.estadoTransitoFact===estadoTransitoFact ? Object.assign({}, z, { 'contactos': [...z.contactos, { 'id': this.state.countContactos++, 'nombre': '', 'correo': '' }] }) : z),countContactos:this.state.countContactos++ });
  }

  onChangeNombreContacto = (e, id, codClie, estadoTransitoFact) => {
    this.setState({ clientes: this.state.clientes.map(z => z.codClie === codClie && z.estadoTransitoFact===estadoTransitoFact ? Object.assign({}, z, { 'contactos': z.contactos.map(contact => contact.id === id ? Object.assign(contact, { 'nombre': e.target.value }) : contact) }) : z) });
  }

  onChangeCorreoContacto = (e, id, codClie, estadoTransitoFact) => {
    this.setState({ clientes: this.state.clientes.map(z => z.codClie === codClie && z.estadoTransitoFact===estadoTransitoFact? Object.assign({}, z, { 'contactos': z.contactos.map(contact => contact.id === id ? Object.assign(contact, { 'correo': e.target.value }) : contact) }) : z) });
  }


  render() {
    const { step } = this.state;

    console.log(this.state.clientes);

    const { tipoDocumento, formaPago, entidadFinanciera,maestroGenericoTipoSolicitud } = this.props;
    const stepsTitle = ['Datos de solicitud', 'Datos del cliente', 'Tipo de solicitud', 'Confirmar'];

    if (!tipoDocumento || !formaPago || !entidadFinanciera || !maestroGenericoTipoSolicitud) return null;

    return (
      <div>
      <Modal title='Solicitar facturacion' idModal='solicitar-facturacion' isOpen closeModal={this.props.closeModal} modalSize='modal-dialog modal-lg'>
        <div className='modalBleed'>
          <Steps stepsTitle={stepsTitle} step={step} />
        </div>
        <div className='fdv-solicFact'>
          {
            step === 1 &&
            <FirstStep
              nextStep={this.nextStep}
              documentos={tipoDocumento.tablaMaestroLogistica}
              entidades={entidadFinanciera.itemList}
              formasPago={formaPago.itemList}
              pedidos={this.state.pedidos}
              formaPagoOption={this.state.formaPagoOption}
              changeOptionFormaPago={this.changeOptionFormaPago}
              documentoRadio={this.state.documentoRadio}
              changeRadioDocumento={this.changeRadioDocumento}
              entidadFinancieraOption={this.state.entidadFinancieraOption}
              changeOptionEntidadFinanciera={this.changeOptionEntidadFinanciera}
              clientes={this.state.clientes}
              getCliente={this.getCliente}
              facturacionListado={this.state.facturacionListado}
              facturacionListadoCheckBox={this.state.facturacionListadoCheckBox}
              llamadaProformaOrTabProforma={this.props.llamadaProformaOrTabProforma}
              arrayAsignarFacturacion={this.state.arrayAsignarFacturacion}
              removeItems={this.removePedidos}
              facturacionListadoSeleccionado={this.state.facturacionListadoSeleccionado}
              fnRemovePedidosSeleccionados={this.fnRemovePedidosSeleccionados}
              listProformaOrTabProforma={this.props.listProformaOrTabProforma!==undefined?this.props.listProformaOrTabProforma:this.state.facturacionListadoSeleccionado}
            />
          }
          {
            step === 2 &&
            <SecondStep
              nextStep={this.nextStep}
              previousStep={this.previousStep}
              pedidos={this.state.pedidos}
              contactos={this.state.contactos}
              clickQuitarContacto={this.clickQuitarContacto}
              clickAgregarContacto={this.clickAgregarContacto}
              onChangeNombreContacto={this.onChangeNombreContacto}
              onChangeCorreoContacto={this.onChangeCorreoContacto}
              direcciones={this.state.direcciones}
              clientes={this.state.clientes}
              getCliente={this.getCliente}
              changeOptionDireccion={this.changeOptionDireccion}
            />
          }
          {
            step === 3 &&
            <ThirdStep
              nextStep={this.nextStep}
              previousStep={this.previousStep}
              maestroGenericoTipoSolicitud={this.props.maestroGenericoTipoSolicitud}
              pedidos={this.state.pedidos}
              changeState={this.changeState}
              getCliente={this.getCliente}
            />
          }

          {
            step === 4 &&
            <FourthStep
              previousStep={this.previousStep}
              colaboradores={this.props.colaboradores}
              colaborador={this.state.colaborador}
              changeColaborador={this.changeColaborador}
              selectColaborador={this.selectColaborador}
              colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}
              removeColaborador={this.removeColaborador}
              pedidos={this.state.pedidos}
              clientes={this.state.clientes}
              maestroGenericoTipoSolicitud={this.props.maestroGenericoTipoSolicitud}
              idFichaVenta={this.props.idFichaVenta}
              grabarFacturacion={this.grabarFacturacion}
            />
          }
        </div>


      </Modal>
      {   this.state.alertWarnnigOpen &&
        <Alert type='alert-warning alertModal' icon='ion-alert-circled' closeAlert={this.closeAlert}>
          <p>Seleccione un Documento, Tipo de pago, Entidad financiera.</p>
        </Alert>
      }
      {
        this.props.entidadFinanciera && this.props.entidadFinanciera.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar entidades financiera</p>
          </Alert> : null
      }
      {
        this.props.tipoDocumento && this.props.tipoDocumento.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar entidades financiera</p>
          </Alert> : null
      }
      {
        this.props.maestroGenericoTipoSolicitud && this.props.maestroGenericoTipoSolicitud.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar maestroGenericoTipoSolicitud</p>
          </Alert> : null
      }
      {
        this.props.colaboradores && this.props.colaboradores.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar colaboradores</p>
          </Alert> : null
      }

      {
        this.props.contactosClientesFacturacion && this.props.contactosClientesFacturacion.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar entidades contactosClientesFacturacion</p>
          </Alert> : null
      }
      </div>
    );


  }
}

function mapStateToProps(state) {
  return {
    entidadFinanciera: state.entidadFinanciera,
    formaPago: state.formaPago,
    tipoDocumento: state.tipoDocumento,
    maestroGenericoTipoSolicitud:state.maestroGenericoTipoSolicitud,
    colaboradores : state.colaboradores,
    contactosClientesFacturacion: state.contactosClientesFacturacion
  };
}

export default connect(
  mapStateToProps,
  { fetchEntidadFinanciera, fetchFormaPago, fetchTipoDocumento,fetchMaestroTipoSolicitudFacturacion,fetchColaboradores,clearColaboradores,fetchGrabarFacturacion,fetchContactosClientes }

)(SolicitarFacturacion);



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitarFacturacion/index.js